import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

// Define the base API
export const resultCompareApi = createApi({
    reducerPath: 'resultCompareApi',
    baseQuery: baseQuery(),
    tagTypes: ['ResultCompare'],
    endpoints: (builder) => ({
        // list results API
        listResultCompares: builder.query({
            query: (body) => ({
                url: `/result`,
                method: 'POST',
                body: body,
            }),
            providesTags: ['ResultCompare'],
        }),
        // fetch an result by id
        fetchResultCompare: builder.query({
            query: (id) => ({
                url: `/result/${id}`,
            }),
        }),
    }),
});

export const {
    useListResultComparesQuery,
    useFetchResultCompareQuery,
} = resultCompareApi;

export default resultCompareApi;
